import React from "react"
import { VenueCategory } from "../../../../types/venue";
import SubCategoryBoxView from "./SubCategoryBoxView";

// @ts-ignore
import Styles from "./SubCategoriesHorizontalList.module.sass"

type SubCategoriesHorizontalListPropType = {
  min: boolean
  selectedRootCategory: VenueCategory,
  categories: VenueCategory[],
  onCategoryClick: (id: string) => {}
}

const SubCategoriesHorizontalList: React.FC<SubCategoriesHorizontalListPropType> = (props: SubCategoriesHorizontalListPropType) => {

  const { min = 2, selectedRootCategory, categories, onCategoryClick } = props;

  const filteredCategories = categories.filter(category => category.parent_id == selectedRootCategory.id && !!category.app_image_url)

  if (filteredCategories.length < min) {
    return null
  }

  return <div className={Styles.container}>
    {filteredCategories.map((category) => <SubCategoryBoxView key={category.id}
                                                              onClick={onCategoryClick}
                                                              category={category}/>)}
  </div>
}

export default SubCategoriesHorizontalList
